import React, { useState } from 'react';
import { BringzzButton, BringzzText } from "@bringzz/components";
import { useNavigation } from 'context/NavigationContext';
import {
	BringzzInput,
	BringzzDate,
	BringzzPageContainer,
	BringzzIcon,
	BringzzImageUpload,
	BringzzBottomDrawer,
	BringzzCheckbox
} from "@bringzz/components";
import { useLocation } from 'react-router-dom';

function useQuery() {
	return new URLSearchParams(useLocation().search);
}

const BankDetailsPage = () => {
	const { backPress } = useNavigation();

	const { navigate } = useNavigation();

	return (
		<BringzzPageContainer
			header={{
				left: (
					<BringzzIcon
						size='22'
						icon='IconChevronLeft'
						folder='LineIcons'
						className='cursor-pointer'
						onClick={backPress}
					/>
				)
			}}
			footer={
				<div className='px-4 mb-4'>
					<BringzzButton
						size='lg'
						className='bg-magic-lilac w-full flex justify-center text-midnight-blue'
						onClick={() => {
							navigate('/register/pharmacy/card/');
						}}
					>
						Continue
					</BringzzButton>
				</div>
			}
			authenticated={false}
		>
			<div className='relative flex justify-center bg-magic-lilac/20'>
				<div className='relative bg-white w-full bg-cover bg-center flex flex-col'>
					{/* Content */}
					<div className='flex-grow flex flex-col py-8 px-4'>
						<div className='z-10 flex flex-col '>
							<div className='flex flex-col text-center space-y-6 mx-auto md:max-w-lg lg:max-w-xl xl:max-w-2xl'>
								<BringzzText tag='h1' className='text-midnight-blue'>
									Bank details
								</BringzzText>
								<BringzzText
									tag='h4'
									className='text-midnight-blue/25 font-normal'
								>
									Let us know where your pharmacy payments should be made to.
									Lorem ipsum dolor sit amet est.
								</BringzzText>
							</div>
							<div className='space-y-6'>
								<div className='space-y-4'>
									<BringzzInput
										label='Account Holder Name'
										placeholder='Account Holder Name'
									/>
									<BringzzInput
										label='IBAN'
										placeholder='IBAN'
										hint='We only allow Austrian and German bank accounts.'
									/>
									<BringzzInput label='BIC' placeholder='BIC' />

									<div className='flex items-center gap-x-4 mt-6'>
										<div className='grow bg-midnight-blue/20 h-[1px]'></div>
										<div>
											<BringzzText
												tag='h4'
												className='text-midnight-blue/40 font-normal'
											>
												or
											</BringzzText>
										</div>
										<div className='grow bg-midnight-blue/20 h-[1px]'></div>
									</div>

									<div className='mt-12'>
										<BringzzButton
											size='lg'
											className='bg-white border border-midnight-blue w-full flex justify-center text-midnight-blue'
										// onClick={() => {
										// 	navigate('/home');
										// }}
										>
											Register with Stripe
										</BringzzButton>
									</div>

									<div className='p-4 bg-magic-lilac/20'>
										<BringzzText
											tag='h4'
											className='font-light text-midnight-blue/40'
										>
											For verification reasons we will transfer you a small
											amount. Please enter the PIN from the transfer reference
											later under Settings.
										</BringzzText>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</BringzzPageContainer>
	);
};

export default BankDetailsPage;
